module.exports = __webpack_public_path__ + "img/icon_login_logo.b7c06a5c.svg";